export const projectOrPortfolioPath = ({projectId, portfolioId}) => portfolioId ? `/portfolios/${portfolioId}` : `/projects/${projectId}`
